module.exports = __webpack_public_path__ + "img/Element1_Fehler_Ziffernrechnen.daca9bd7.png";